// import AWSAppSyncClient from 'aws-appsync';
import { ApolloClient, InMemoryCache, createHttpLink, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

// Resolve backend base URL safely even if 'process' is not defined (older admin pages)
const BACKEND_BASE =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_BACKEND_URL) ||
  '';

const GRAPHQL_URI = BACKEND_BASE
  ? `${BACKEND_BASE}/graphql`
  : `/graphql`;

const httpLink = createHttpLink({
  uri: GRAPHQL_URI,
  fetchOptions: { credentials: 'include' }
});

try { console.log('🔗 GraphQL URL:', GRAPHQL_URI); } catch (_) {}

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  };
});

async function refreshAccessTokenOnce() {
  try {
    const response = await fetch(`${BACKEND_BASE || ''}/auth/refresh`, {
      method: 'POST',
      credentials: 'include'
    });
    const data = await response.json();
    if (data && data.ok && data.token) {
      localStorage.setItem('token', data.token);
      return data.token;
    }
    return null;
  } catch (e) {
    return null;
  }
}

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  const shouldRetry = !operation.getContext()._retryAfterRefresh;
  const hasUnauth = (graphQLErrors && graphQLErrors.some(e => e.extensions && e.extensions.code === 'UNAUTHENTICATED')) || (networkError && networkError.statusCode === 401);
  if (hasUnauth && shouldRetry) {
    return new ApolloLink((op, fwd) => {
      return new Promise(async (resolve) => {
        const newToken = await refreshAccessTokenOnce();
        if (newToken) {
          op.setContext(({ headers = {} }) => ({
            headers: { ...headers, authorization: `Bearer ${newToken}` },
            _retryAfterRefresh: true
          }));
          resolve(fwd(op));
        } else {
          // give up; propagate original error
          resolve(fwd(op));
        }
      });
    }).request(operation, forward);
  }
});

const client = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache({ addTypename: false })
});

// const client = new AWSAppSyncClient({
//   url: awsconfig.aws_appsync_graphqlEndpoint,
//   region: awsconfig.aws_appsync_region,
//   auth: {
//     type: awsconfig.aws_appsync_authenticationType,
//     jwtToken: async () =>
//       (await Auth.currentSession()).getIdToken().getJwtToken()
//   }
// });

export default client;
